import script from "./AudienceManagementTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudienceManagementTable.vue?vue&type=script&lang=ts&setup=true"

import "./AudienceManagementTable.vue?vue&type=style&index=0&id=4c024444&lang=scss"

const __exports__ = script;

export default __exports__